import { Link } from '@tanstack/react-router';
import Icon from '../icon';
import { createUseStyles } from 'react-jss';
import { getRoute, RouteKey } from '@/router/helpers';
import Text from '../text';
import { ScrollAnchorId } from '../scroll-anchor/helpers';
import { FC } from 'react';
import useFeature from '@/hooks/use-feature.hook';

interface Props {
  routeKey: RouteKey;
  scrollId?: ScrollAnchorId;
  size?: 'small' | 'medium' | 'large';
  search?: Record<string, string>;
}

const useStyles = createUseStyles({
  pageLink: {
    display: 'inline-flex',
    flexDirection: 'row',
    alignItems: 'center',
    gap: 4,
  },
});

const PageLink: FC<Props> = ({ routeKey, scrollId, size = 'medium', search }) => {
  const { hasPolicyV2, hasPolicyV1 } = useFeature();
  const styles = useStyles();

  let versionedRouteKey = routeKey;

  if (hasPolicyV1 && routeKey === 'default-policy') {
    versionedRouteKey = 'default-policy-v1';
  }

  if (hasPolicyV2 && routeKey === 'group-policies') {
    versionedRouteKey = 'scope-policies';
  }

  const { label, icon, link } = getRoute(versionedRouteKey);

  return (
    <Link to={link} search={search} hash={scrollId ?? undefined} className={styles.pageLink}>
      <Icon name={icon} color="link" size="x-small" />
      <Text bold inline size={size}>
        {label}
      </Text>
    </Link>
  );
};

export default PageLink;
